import { EntitySelectEntity, EntitySelectSubEntity } from '@factorialco/f0-react/dist/experimental'
import { AvatarNameForSelectFragment, EmployeeForSelectFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import { DisplayNameStrategy, resolveEmployeeDisplayName } from 'modules/core/lib/employeeName'

import { Groups } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import {
  EmployeeForSelectFragmentNoAccess,
  GroupType,
} from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'

export function mapToEmployeeFragment(a: EntitySelectEntity): EmployeeForSelectFragment {
  const [firstname, ...otherNames] = a.name.split(' ')

  return {
    __typename: 'EmployeesEmployeeName',
    id: Number(a.id),
    firstName: firstname ?? '',
    fullName: a.name,
    lastName: otherNames.join(' '),
    access: {
      __typename: 'ApiCoreAccess',
      id: 0,
      avatar: a.avatar,
    },
  }
}

export function mapSelectedEmployees(
  selectedGroup: GroupType,
  selectedEmployees: EmployeeForSelectFragmentNoAccess[],
  employeeEntities: EntitySelectEntity[]
): EntitySelectEntity[] {
  if (selectedGroup === Groups.ALL) {
    return employeeEntities.filter((el) => selectedEmployees.find((el2) => el2.id == el.id))
  }
  return employeeEntities
    .map((parent) => {
      return {
        ...parent,
        subItems:
          parent.subItems?.filter((el) => selectedEmployees.find((el2) => el2.id == el.subId)) ??
          [],
      }
    })
    .filter((el) => el.subItems.length > 0)
}

export function subMapToEmployeeFragment(
  a?: EntitySelectSubEntity
): EmployeeForSelectFragment | null {
  if (!a) return null

  const [firstname, ...otherNames] = a.subName.split(' ')

  return {
    __typename: 'EmployeesEmployeeName',
    id: Number(a.subId),
    firstName: firstname ?? '',
    fullName: a.subName,
    lastName: otherNames.join(' '),
    access: {
      __typename: 'ApiCoreAccess',
      id: 0,
      avatar: a.subAvatar,
    },
  }
}

export function mapEmployees(
  employees?: AvatarNameForSelectFragment[],
  excludedIds: number[] = [],
  displayNameStrategy: DisplayNameStrategy = 'preferredOrFull'
): EntitySelectEntity[] {
  if (!employees) return []
  return employees
    .map((emp) => ({
      id: emp.id,
      name: employeeName(emp, displayNameStrategy),
      avatar: emp.avatar?.url ? buildUrl(emp.avatar?.url) : undefined,
      searchKeys: [
        emp.preferredName ? `${emp.preferredName} ${emp.lastName}` : null,
        `${emp.firstName} ${emp.lastName}`,
      ].filter(Boolean),
    }))
    .filter((el) => !excludedIds.includes(el.id))
}

function employeeName(
  employee: AvatarNameForSelectFragment,
  displayNameStrategy: DisplayNameStrategy = 'preferredOrFull'
) {
  return resolveEmployeeDisplayName(
    {
      fullName: employee.fullName,
      lastName: employee.lastName,
      preferredName: employee.preferredName,
    },
    displayNameStrategy
  )
}
